import { useEffect, useState } from "react";
// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductTableRow from "./ProductTableRow";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

const ProductData = () => {
  const { products, isLoading } = useSelector((state) => state.products);
  const dispatch = useDispatch();

  // const [productData, setProductData] = useState([]);
  // const [searchTerm, setSearchTerm] = useState("");

  const [data, setData] = useState([]);
  const [order, setOrder] = useState("ASC");

  useEffect(() => {
    setData(products);
  }, [products]);

  const sorting = (col) => {
    console.log(col);

    if (order === "ASC") {
      const sorted = [...data].sort((a, b) => (a[col] < b[col] ? 1 : -1));
      setData(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...data].sort((a, b) => (a[col] > b[col] ? 1 : -1));
      setData(sorted);
      setOrder("ASC");
    }
  };

  return (
    <TableContainer sx={{ whiteSpace: "nowrap" }}>
      <Table aria-label='customized table'>
        <TableHead
          sx={{
            "&:hover": false,
          }}
        >
          <TableRow>
            <TableCell onClick={() => sorting("id")}>Id</TableCell>
            <TableCell onClick={() => sorting("product_name")}>
              Product Name
            </TableCell>
            <TableCell onClick={() => sorting("product_amount")}>
              Product Amount
            </TableCell>
            <TableCell onClick={() => sorting("product_discount_price")}>
              Product Discount Price
            </TableCell>
            <TableCell>Product Image</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
          {/* <TableRow>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by id'
                id='id-searchbox'
                label='Id'
                name='searchId'
                // onChange={handleSearch}
              />
            </TableCell>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by name'
                id='name-searchbox'
                label='Product Name'
                name='searchuser'
                // onChange={handleSearch}
              />
            </TableCell>

            <TableCell>
              <TextField
                fullWidth
                helperText='Search by email'
                id='email-searchbox'
                label='Product Amount'
                name='searchstatus'
                // onChange={handleSearch}
              />
            </TableCell>
          </TableRow> */}
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography variant='p' align='center'>
                  Loading...
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            <ProductTableRow row={data}></ProductTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    // <Typography>Order data</Typography>
  );
};

export default ProductData;
